import React from "react";
import { Icon, IconProps } from "@chakra-ui/icons";
import {
  FaCircle,
  FaCog,
  FaList,
  FaUserFriends,
  FaUserLock,
} from "react-icons/fa";
import {
  FiUser,
  FiUserPlus,
  FiLock,
  FiMoreHorizontal,
  FiPlus,
  FiLogOut,
  FiX,
  FiCheck,
  FiTrash2,
  FiEdit,
  FiRefreshCw,
  FiCreditCard,
  FiSmartphone,
  FiRepeat,
  FiZap,
} from "react-icons/fi";
import { IconType } from "react-icons/lib";

/**
 * Wraps a non Chakra icon in a <Icon/> component
 * @param icon
 * @returns
 */
const wrapIcon = (icon: IconType) => {
  return (props: IconProps) => <Icon {...props} as={icon} />;
};

export const CogIcon = wrapIcon(FaCog);

export const CircleIcon = wrapIcon(FaCircle);

export const ListIcon = wrapIcon(FaList);

export const UserIcon = wrapIcon(FiUser);

export const UsersIcon = wrapIcon(FaUserFriends);

export const UserPlusIcon = wrapIcon(FiUserPlus);

export const UserLockIcon = wrapIcon(FaUserLock);

export const LockIcon = wrapIcon(FiLock);

export const MoreHorizontal = wrapIcon(FiMoreHorizontal);

export const PlusIcon = wrapIcon(FiPlus);

export const LogoutIcon = wrapIcon(FiLogOut);

export const DeleteIcon = wrapIcon(FiX);

export const EditIcon = wrapIcon(FiEdit);

export const CheckIcon = wrapIcon(FiCheck);

export const TrashIcon = wrapIcon(FiTrash2);

export const RefreshIcon = wrapIcon(FiRefreshCw);

export const CardIcon = wrapIcon(FiCreditCard);

export const PhoneIcon = wrapIcon(FiSmartphone);

export const TransferIcon = wrapIcon(FiRepeat);

export const ZapIcon = wrapIcon(FiZap);
